<script setup lang="ts">
import {
    DialogClose,
    DialogContent,
    type DialogContentEmits,
    type DialogContentProps,
    DialogOverlay,
    DialogPortal,
    useEmitAsProps,
} from "radix-vue";
import { X } from "lucide-vue-next";
import { cn } from "@/lib/utils";

const props = defineProps<DialogContentProps & { class?: string }>();
const emits = defineEmits<DialogContentEmits>();

const emitsAsProps = useEmitAsProps(emits);
</script>

<template>
    <DialogPortal>
        <DialogOverlay
            class="inset-0 bg-black/75 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 dark:bg-stone-950/80 fixed z-50"
        />
        <DialogContent
            :class="
                cn(
                    'top-4 max-w-lg border-iron-200 bg-white shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[5%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[5%] dark:border-stone-800 dark:bg-stone-950 sm:top-[64px] sm:rounded-lg md:w-full fixed left-1/2 z-50 grid w-full -translate-x-1/2 border duration-200',
                    props.class,
                )
            "
            v-bind="{ ...props, ...emitsAsProps }"
        >
            <slot />

            <DialogClose
                class="right-3 top-3 rounded-md p-0.5 hover:bg-stone-100 dark:hover:bg-stone-800 absolute transition-colors"
            >
                <X class="h-5 w-5 text-iron-500" />
                <span class="sr-only">Close</span>
            </DialogClose>
        </DialogContent>
    </DialogPortal>
</template>
